import { ChangeDetectionStrategy, Component, EventEmitter, OnChanges, OnInit, Output, input, model, output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faWarning, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Editor, Toolbar } from 'ngx-editor';
import { Subject } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { AccomplishmentService } from 'src/app/services/accomplishment.service';

@Component({
  selector: 'app-view-accomplishment-additional',
  templateUrl: './view-accomplishment-additional.component.html',
  styleUrls: ['./view-accomplishment-additional.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})

export class ViewAccomplishmentAdditionalComponent implements OnChanges, OnInit {
  //icons
  faWarning = faWarning;
  faArrowUpRightFromSquare = faArrowUpRightFromSquare;
  faCircleXmark = faCircleXmark as IconProp;

  reg = APP_CONSTANTS.URL_REGEX;

  report = input.required<any>();
  reportList = input.required<any>();
  currentUser = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
  @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  saveSubject = new Subject<any>();
  additional_reports: any[] = [];

  form = this.formBuilder.group({
    success_failure: ["", [Validators.maxLength(6000), Validators.required]],
    recommendations: ["", [Validators.maxLength(6000), Validators.required]],
    plans: ["", [Validators.maxLength(6000), Validators.required]],
  });

  toolbar: Toolbar = APP_CONSTANTS.EDITOR_TOOLBAR;
  editor1 = new Editor();
  editor2 = new Editor();
  editor3 = new Editor();

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly accomplishmentService: AccomplishmentService,
  ) {
  }

  ngOnInit(): void {
    this.status.emit(undefined);
    this.form.patchValue({
      success_failure: this.customATOB(this.report().success_failure ?? ""),
      recommendations: this.customATOB(this.report().recommendations ?? ""),
      plans: this.customATOB(this.report().plans ?? ""),
    })
    this.loaded.emit(3);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/view-report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 4 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/view-report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: 2 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.reportList()[0].assessment_id, tab: 2 } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/view-report-accomplishment'], { queryParams: { accomplishment_id: this.report().accomplishment_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  onChangeEditor(html: any, field: any) {
    if (html == '<p></p>') {
      let patch = '{"' + field + '": ""}'
      this.form.patchValue(JSON.parse(patch))
    }
  }

  gatherData(): any {
    let additionalReports = this.additional_reports.map((report: any) => {
      return {
        additional_report_id: report.additional_report_id,
        name: report.form.value.name ?? '',
        link: report.form.value.link ?? ''
      }
    })
    let data: any = {
      success_failure: this.form.value.success_failure as string | null,
      recommendations: this.form.value.recommendations as string | null,
      plans: this.form.value.plans as string | null,
      additional_reports: additionalReports,
    };
    let allFieldsFilled = true

    for (let field in this.form.controls) {
      if (this.form.get(field)?.value === null || this.form.get(field)?.value === "") {
        allFieldsFilled = false
      }
    }
    data.allFieldsFilled = allFieldsFilled
    return data
  }

  save_close() {
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  customBTOA(s: string): string {
    return btoa(s.replaceAll(/[\u00A0-\u2666]/g, function (c) {
      return '&#' + c.codePointAt(0) + ';';
    }));
  }
}
